import { render, staticRenderFns } from "./RenewableEnergySources.vue?vue&type=template&id=2f0f89c4&scoped=true&"
import script from "./RenewableEnergySources.vue?vue&type=script&lang=js&"
export * from "./RenewableEnergySources.vue?vue&type=script&lang=js&"
import style0 from "./RenewableEnergySources.vue?vue&type=style&index=0&id=2f0f89c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0f89c4",
  null
  
)

export default component.exports